var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_539_291541)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DE2626",
    height: 14.9525,
    rx: 7.47627,
    stroke: "#F05858",
    strokeWidth: 1.39296,
    width: 14.9525,
    x: 2.01289,
    y: 2.19843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96918 6.96723C7.10518 6.83124 7.32567 6.83124 7.46167 6.96723L9.30487 8.81043L11.1481 6.96723C11.2841 6.83124 11.5045 6.83124 11.6405 6.96723C11.7765 7.10323 11.7765 7.32372 11.6405 7.45972L9.79735 9.30291L11.6405 11.1461C11.7765 11.2821 11.7765 11.5026 11.6405 11.6386C11.5045 11.7746 11.2841 11.7746 11.1481 11.6386L9.30487 9.7954L7.46167 11.6386C7.32567 11.7746 7.10518 11.7746 6.96918 11.6386C6.83319 11.5026 6.83319 11.2821 6.96918 11.1461L8.81238 9.30291L6.96918 7.45972C6.83319 7.32372 6.83319 7.10323 6.96918 6.96723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96918 6.96723C7.10518 6.83124 7.32567 6.83124 7.46167 6.96723L9.30487 8.81043L11.1481 6.96723C11.2841 6.83124 11.5045 6.83124 11.6405 6.96723C11.7765 7.10323 11.7765 7.32372 11.6405 7.45972L9.79735 9.30291L11.6405 11.1461C11.7765 11.2821 11.7765 11.5026 11.6405 11.6386C11.5045 11.7746 11.2841 11.7746 11.1481 11.6386L9.30487 9.7954L7.46167 11.6386C7.32567 11.7746 7.10518 11.7746 6.96918 11.6386C6.83319 11.5026 6.83319 11.2821 6.96918 11.1461L8.81238 9.30291L6.96918 7.45972C6.83319 7.32372 6.83319 7.10323 6.96918 6.96723Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.928639
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21.1646,
    id: "filter0_d_539_291541",
    width: 21.1627,
    x: 0.513249,
    y: 0.698796
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.60631,
    dy: 1.60631
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.20474
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_539_291541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_539_291541",
    mode: "normal",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.63ee4d567f986909d78f1e8c7938b11f.svg";
export { ForwardRef as ReactComponent };